/* ContactsView holds all contacts-related stuff */
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { Tinode } from 'tinode-sdk';

import ContactList from '../widgets/contact-list.jsx';

import { updateFavicon } from '../lib/utils.js';

const messages = defineMessages({
  archived_contacts_title: {
    id: "archived_contacts",
    defaultMessage: "Archived contacts ({count})",
    description: "Label for archived chats"
  },
  qq_people_empty: {
    id: "qq_people_empty",
    defaultMessage: "还没有联系人\n发起一个聊天吧",
    description: "Empty state for the contacts tab"
  },
  qq_messages_empty: {
    id: "qq_messages_empty",
    defaultMessage: "还没有会话\n点击右上角 + 发起聊天",
    description: "Empty state for the messages tab"
  }
});

export default class ContactsView extends React.Component {
  constructor(props) {
    super(props);

    this.handleAction = this.handleAction.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleClearFilter = this.handleClearFilter.bind(this);

    this.state = {
      ...ContactsView.deriveStateFromProps(props),
      filter: ''
    };
  }

  static deriveStateFromProps(props) {
    const contacts = [];
    let unreadThreads = 0;
    let archivedCount = 0;

    const me = props.tinode.getMeTopic();
    props.chatList.forEach(c => {
      const blocked = c.acs && !c.acs.isJoiner();
      c.pinned = me.pinnedTopicRank(c.topic);

      // Contacts tab: only p2p chats, no archived/blocked entries.
      if (props.people) {
        if (!blocked && Tinode.isP2PTopicName(c.topic)) {
          contacts.push(c);
        }
        return;
      }

      // Show only blocked contacts only when props.blocked == true.
      if (blocked && props.blocked) {
        contacts.push(c);
      }
      if (blocked || props.blocked) {
        return;
      }

      if (c.private && c.private.arch) {
        if (props.archive) {
          contacts.push(c);
        } else {
          archivedCount ++;
        }
      } else if (!props.archive) {
        contacts.push(c);
        unreadThreads += c.unread > 0 ? 1 : 0;
      }
    });

    contacts.sort((a, b) => {
      const pin = b.pinned - a.pinned;
      return pin != 0 ? pin : (b.touched || 0) - (a.touched || 0);
    });

    if (!props.people && archivedCount > 0) {
      contacts.push({
        action: 'archive',
        title: messages.archived_contacts_title,
        values: {count: archivedCount}
      });
    }

    return {
      contactList: contacts,
      unreadThreads: unreadThreads
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.chatList != this.props.chatList ||
        prevProps.archive != this.props.archive ||
        prevProps.blocked != this.props.blocked ||
        prevProps.people != this.props.people) {
      const newState = ContactsView.deriveStateFromProps(this.props);
      this.setState(newState);
      if (newState.unreadThreads != prevState.unreadThreads) {
        updateFavicon(newState.unreadThreads);
      }
    }
  }

  handleAction(action_ignored) {
    this.props.onShowArchive();
  }

  handleFilterChange(e) {
    this.setState({filter: e.target.value});
  }

  handleClearFilter() {
    this.setState({filter: ''});
  }

  render() {
    const isPeople = !!this.props.people;
    const filter = this.state.filter;
    const filterFunc = (value, fields) => fields.some(
      field => String(field || '').toLowerCase().includes(value.toLowerCase()));

    const contactList = emptyMessage => (
      <ContactList
        tinode={this.props.tinode}
        connected={this.props.connected}
        contacts={this.state.contactList}
        emptyListMessage={emptyMessage}
        topicSelected={this.props.topicSelected}
        myUserId={this.props.myUserId}
        showOnline={true}
        showUnread={true}
        filter={filter}
        filterFunc={filterFunc}
        onTopicSelected={this.props.onTopicSelected}
        showContextMenu={this.props.showContextMenu}
        onAction={this.handleAction} />
    );

    return (
      <div className="qq-list-view">
        <div className="qq-search">
          <i className="material-icons">search</i>
          <input type="search" value={filter}
            placeholder={isPeople ? '搜索联系人' : '搜索会话'}
            onChange={this.handleFilterChange} />
          {filter ?
            <button type="button" className="qq-search-clear" title="清除"
              onClick={this.handleClearFilter}>
              <i className="material-icons">close</i>
            </button> : null}
        </div>
        {isPeople ?
          <FormattedMessage id="qq_people_empty"
            defaultMessage={'还没有联系人\n发起一个聊天吧'}
            description="Empty state for the contacts tab">{
            no_contacts => contactList(no_contacts)
          }</FormattedMessage> :
          <FormattedMessage id="qq_messages_empty"
            defaultMessage={'还没有会话\n点击右上角 + 发起聊天'}
            description="Empty state for the messages tab">{
            no_contacts => contactList(no_contacts)
          }</FormattedMessage>
        }
        {this.state.contactList.length == 0 && !filter && this.props.onNewTopic ?
          <button type="button" className="qq-empty-action" onClick={this.props.onNewTopic}>
            <i className="material-icons">add</i>
            发起聊天
          </button> : null}
      </div>
    );
  }
};
